import React from "react";
import No_pronouns from "./images/Pronouns compass/Svgs/No_pronouns.jsx";
import He_him from "./images/Pronouns compass/Svgs/He_him.jsx";
import He_other from "./images/Pronouns compass/Svgs/He_other.jsx";
import He_them from "./images/Pronouns compass/Svgs/He_them.jsx";
import He_they_other from "./images/Pronouns compass/Svgs/He_they_other.jsx";
import Other from "./images/Pronouns compass/Svgs/Other.jsx";
import Poly from "./images/Pronouns compass/Svgs/Poly.jsx";
import She_her from "./images/Pronouns compass/Svgs/She_her.jsx";
import She_him_other from "./images/Pronouns compass/Svgs/She_him_other.jsx";
import She_him_them_other from "./images/Pronouns compass/Svgs/She_him_them_other.jsx";
import She_him_them from "./images/Pronouns compass/Svgs/She_him_them.jsx";
import She_him from "./images/Pronouns compass/Svgs/She_him.jsx";
import She_other from "./images/Pronouns compass/Svgs/She_other.jsx";
import She_them from "./images/Pronouns compass/Svgs/She_them.jsx";
import She_they_other from "./images/Pronouns compass/Svgs/She_they_other.jsx";
import They_other from "./images/Pronouns compass/Svgs/They_other.jsx";
import They_them from "./images/Pronouns compass/Svgs/They_them.jsx";
import NoPoly from "./images/Pronouns compass/Svgs/NoPoly.jsx";

const pronouns = (width = "200px", height = "200px") => {
  return {
    //single
    she: <She_her width={width} height={height} id={"pronounsImage"} />,
    they: <They_them width={width} height={height} id={"pronounsImage"} />,
    he: <He_him width={width} height={height} id={"pronounsImage"} />,
    other: <Other width={width} height={height} id={"pronounsImage"} />,
    na: <No_pronouns width={width} height={height} id={"pronounsImage"} />,

    //double
    she_they: <She_them width={width} height={height} id={"pronounsImage"} />,
    he_she: <She_him width={width} height={height} id={"pronounsImage"} />,
    other_she: <She_other width={width} height={height} id={"pronounsImage"} />,
    other_they: (
      <They_other width={width} height={height} id={"pronounsImage"} />
    ),
    he_they: <He_them width={width} height={height} id={"pronounsImage"} />,
    he_other: <He_other width={width} height={height} id={"pronounsImage"} />,

    //triple
    he_she_they: (
      <She_him_them width={width} height={height} id={"pronounsImage"} />
    ),
    he_other_they: (
      <He_they_other width={width} height={height} id={"pronounsImage"} />
    ),
    other_she_they: (
      <She_they_other width={width} height={height} id={"pronounsImage"} />
    ),
    he_other_she: (
      <She_him_other width={width} height={height} id={"pronounsImage"} />
    ),

    //quad
    he_other_she_they: (
      <She_him_them_other width={width} height={height} id={"pronounsImage"} />
    ),

    //poly
    grey: <Poly width={width} height={height} id={"poly"} />,
    grey_2: <NoPoly width={width} height={height} id={"no_poly"} />,
  };
};

export default pronouns;
